module.exports = {
    testInstanceManagement: { name: 'testInstanceManagement', title: 'Test Instances' },
    scenarioManagement: { name: 'scenarioManagement', title: 'Scenarios' },
    deviceManagement: { name: 'deviceManagement', title: 'Devices' },
    addNewDevice: { name: 'addNewDevice', title: 'Add New Device' },
    editDevice: { name: 'editDevice', title: 'Edit Device' },
    clusterManagement: { name: 'clusterManagement', title: 'Clusters' },
    createCluster: { name: 'createCluster', title: 'Create Cluster' },
    editCluster: { name: 'editCluster', title: 'Edit Cluster' },
    addNewTestInstance: { name: 'addNewTestInstance', title: 'Add New Test Instance' },
    editTestInstance: { name: 'editTestInstance', title: 'Edit Test Instance' },
    addDevicesToTest: { name: 'addDevicesToTest', title: 'Add Devices To Test' },
    editAddDevicesToTest: { name: 'editAddDevicesToTest', title: 'Edit Add Devices To Test' },
    analyticsTestInstanceList: { name: 'analyticsTestInstanceList', title: 'Analytics' },
    analytics: { name: 'analytics', title: 'Analytics' },
    compareTestInstances: { name: 'compareTestInstances', title: 'Compare Test Instances' },
    mapAnalytics: { name: 'mapAnalytics', title: 'Map Analytics' },
    matrixAnalysis: { name: 'matrixAnalysis', title: 'Matrix Analysis' },
    batteryStats: { name: 'batteryStats', title: 'Battery Stats' },
    addNewScenario: { name: 'addNewScenario', title: 'Add New Scenario' },
    editScenario: { name: 'editScenario', title: 'Edit Scenario' },
    zonesImport: { name: 'zonesImport', title: 'Zones Import' }
};
